import gsap from 'gsap';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';



const galleryComponentFunctions = (slider) => {

    const swiper = new Swiper(slider, {
        speed: 1000,
        slidesPerView: 'auto',
        loop: false,
		spaceBetween: 12,
		slidesOffsetBefore: window.innerWidth * 5/100,
		slidesOffsetAfter: window.innerWidth * 5/100,
        breakpoints: {
            900: {
                slidesPerView: 'auto',
                spaceBetween: 48,
                slidesOffsetBefore: window.innerWidth * 3.5/100,
                slidesOffsetAfter: window.innerWidth * 3.5/100,
            }
        },
		allowTouchMove: true,
		centeredSlides: false,
        modules: [Navigation],
        navigation: {
            nextEl: slider.querySelector('.slider--navigation .swiper-button-next'),
            prevEl: slider.querySelector('.slider--navigation .swiper-button-prev'),
        },
    });

}

const newsSliderComponentFunctions = (slider) => {

    const swiper = new Swiper(slider, {
        speed: 1000,
        slidesPerView: 1.2,
        loop: false,
		spaceBetween: 12,
		slidesOffsetBefore: window.innerWidth * 5/100,
		slidesOffsetAfter: window.innerWidth * 5/100,
        breakpoints: {
            900: {
                slidesPerView: 3.5,
                spaceBetween: 48,
                slidesOffsetBefore: window.innerWidth * 3.5/100,
                slidesOffsetAfter: window.innerWidth * 3.5/100,
            }
        },
		allowTouchMove: true,
		centeredSlides: false,
        modules: [Navigation],
        navigation: {
            nextEl: slider.querySelector('.slider--navigation .swiper-button-next'),
            prevEl: slider.querySelector('.slider--navigation .swiper-button-prev'),
        },
    });

}

export { galleryComponentFunctions, newsSliderComponentFunctions };